/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentsControllerFetchFileQueryResponse, DocumentsControllerFetchFilePathParams, DocumentsControllerFetchFileQueryParams, DocumentsControllerFetchFile400, DocumentsControllerFetchFile401, DocumentsControllerFetchFile403, DocumentsControllerFetchFile404 } from "../../models/documentsController/DocumentsControllerFetchFile";

function getDocumentsControllerFetchFileUrl(id: DocumentsControllerFetchFilePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/documents/${id}/file` as const }  
  return res
}

/**
 * @summary Fetch the actual document file from storage
 * {@link /api/v1/documents/:id/file}
 */
export async function documentsControllerFetchFile(id: DocumentsControllerFetchFilePathParams["id"], params?: DocumentsControllerFetchFileQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentsControllerFetchFileQueryResponse, ResponseErrorConfig<DocumentsControllerFetchFile400 | DocumentsControllerFetchFile401 | DocumentsControllerFetchFile403 | DocumentsControllerFetchFile404>, unknown>({ method : "GET", url : getDocumentsControllerFetchFileUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}